import React, { useState } from 'react'
import { Modal } from 'react-bootstrap'
import ErrorMessage from './errors/errorMessage'
import { useSelector } from 'react-redux';
import { apiUrl } from '../utils/url';
import { createFormdataValues } from '../utils/createFormdataValues';
import { hideLoader, showLoader } from './loader';
import { toast } from 'react-toastify';

const FeedbackModal = ({ show, setShow }) => {
    const [error, setError] = useState([]);
    const [values, setValues] = useState({ type: "Suggestion", message: null });
    const { slug } = useSelector(state => state.slugReducer)
    const closeModal = () => {
        setShow(null)
    }
    function autoResize(textarea) {
        if (textarea.value.length > 160) {
            textarea.style.height = "auto";
            textarea.style.height = textarea.scrollHeight + "px";
        } else {
            textarea.style.height = "60px";
        }
    }
    const handleSubmit = (e) => {
        setError([]);
        e?.preventDefault();
        var api = apiUrl + "/feedback/create";
        showLoader()
            var myHeaders = new Headers();
            myHeaders.append("Authorization", `Bearer ${localStorage?.getItem("token")}`);
            const formdata = createFormdataValues(values);
            formdata.append("project", slug);

            const setOptions = {
                method: "POST",
                body: formdata,
                headers: myHeaders,
            }
            fetch(api, setOptions)
            .then(async (res) => {
                const response = await res?.json();
                if (response?.status_code == 200) {
                    closeModal();
                    hideLoader();
                    toast.success(response?.status_message)
                }else{
                    setError(Object.values(response?.errors));
                    if (Object.keys(response?.errors).length > 0)
                        $(".modal-body").scrollTop(0);
                    hideLoader();
                }
            hideLoader();
          }).catch(() => {
            hideLoader();
          });
    }
    const handleChange = (e) => {
        setValues({...values, [e.target.name]: e.target.value });
    };
    return (
        <Modal centered show={show} onHide={closeModal} className="rename-modal">
            <div class="modal-header create-biolink-header">
                <span class="modal-title create-biolink-heading">Share Feedback</span>
                <button type="button" class="close" onClick={closeModal} aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>

            <div class="modal-body">
                <form action="" id="" method="post" role="form" onSubmit={handleSubmit}>
                    <ErrorMessage error={error} />
                        <div className='form-group'>
                            <div className='zaapGlobal-select'>
                                <select name="type" onChange={handleChange}>
                                    <option selected value="Suggestion">Suggestion</option>
                                    <option value="Report Issue">Report Issue</option>
                                </select>
                            </div>
                        </div>
                        <div className='form-group'>
                            <textarea
                                type="text"
                                className="zaapGlobal-input mt-10px hidden-scroll"
                                name="message"
                                placeholder={"We’re listening..."}
                                onInput={(e) => autoResize(e.target)}
                                style={{height: "60px",maxHeight:"150px"}}
                                onChange={handleChange}
                            >
                            </textarea>
                        </div>
                    <div className='d-flex gap-2 mt-20px align-items-center justify-content-center '>
                        <button onClick={closeModal} className='fs-12 w-50 mt-0 integration-btns integration-btn-grey' type='button'>
                            Cancel
                        </button>
                        <button className='fs-12 w-50 shadow-none  project-blue-btn' type='submit'>
                            <span class="me-2 productlabel2">Submit</span>
                        </button>
                    </div>
                </form>
            </div>
        </Modal>
    )
}

export default FeedbackModal